import React, { Component } from 'react';
import MyDPContent from './MyDPContent';
class Content extends Component {

    _renderPageByUrl() {
        if(this.props.match.params.pagename === 'over-mijndp') {
            return <MyDPContent />
        }
    }
    render() {

        return (
           <div className="card">
                <div className="card__body">
                    <div className="card__content">
                       {this._renderPageByUrl()}
                    </div>
                </div>
            </div>
        );
    }
}


export default Content;



// WEBPACK FOOTER //
// ./src/components/Content/index.js